import React from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Button from 'components/Button';
import styled from 'styled-components';
import {device} from 'styled/device';

import StyledIcon from 'components/acommon/StyledIcon';

export const StyledDesktopBackButton = styled.div`
  padding-top: 40px;
  align-self: flex-start;

  @media (max-width: ${device.mobileXL}) {
    display: none;
  }
`;

type DesktopBackButtonProps = {
  className?: string;
};
function DesktopBackButton({className}: DesktopBackButtonProps) {
  const history = useHistory();
  const {t} = useTranslation();

  return (
    <StyledDesktopBackButton className={className}>
      <Button
        label={t('back_button')}
        icon={<StyledIcon name="backArrow" size="20" />}
        whiteButton
        onClick={history.goBack}
        className="desktopBackButton"
      />
    </StyledDesktopBackButton>
  );
}

export default DesktopBackButton;
